cb.define([], function () {

    var PM_pmc_promotioncheck_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            var gridModel = viewmodel.getGridModel();
            viewmodel.getParams().autoLoad = false;
            gridModel.setShowCheckbox(false);
            gridModel.setState('pagination', false);
            gridModel.setState('showColumnSetting', false);
            var proxy = cb.rest.DynamicProxy.create({
                ensure: {
                    url: '/product/promotionCheck',
                    method: 'POST'
                }
            });
            gridModel.setState('dataSourceMode', 'local');
            var params = {
                data: viewmodel.get('params').datas
            }
            proxy.ensure(params, function (err, result) {
                if (err) {
                    cb.utils.alert(err.message, 'error');
                    return;
                }
                gridModel.setDataSource(result);

            });
        }
    };
    try {
        module.exports = PM_pmc_promotioncheck_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_promotioncheck_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_promotioncheck_VM.Extend.js